import React from 'react';
import CvssCard from './CvssCard';

const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '16px',
  },
};

function CvssDisplay({ securityInfo, translate }) {
  console.log(securityInfo);
  const {
    vectorv4,
    vectorv3,
    vectorv2
  } = securityInfo;

  const availableCvss = [
    { version: '4.0', data: securityInfo, exists: vectorv4 && vectorv4 !== 'None' },
    { version: '3.0', data: securityInfo, exists: vectorv3 && vectorv3 !== 'None' },
    { version: '2.0', data: securityInfo, exists: vectorv2 && vectorv2 !== 'None' },
  ]
    .filter((cvss) => { return cvss.exists; })
    .slice(0, 2);

  if (availableCvss.length === 0) {
    return <p>{translate('modal.cve.cvss_failed_load')}</p>;
  }

  return (
    <div style={styles.container}>
      {availableCvss.map((cvss) => {
        return (
          <CvssCard
            translate={translate}
            key={cvss.version}
            version={cvss.version}
            data={cvss.data}
          />
        );
      })}
    </div>
  );
}

export default CvssDisplay;
